<main class="bg-white position-relative">
  <!-- top_selling_sec -->
  <section class="position-relative overflow-hidden" id="top_selling_sec">
    <div class="top_selling_container padd-top-bot">
      <div class="container product-slider-sec">

        <div class="row align-items-center">
          <div class="col-xl-3 col-md-5">
            <div class="main_def_title">
              <h2 class="text-uppercase text-dark oswald_font font_30 bold_600">Browse Sneakers</h2>
            </div>
          </div>
          <div class="col-xl-9 col-md-7">
            <div class="browse-sneakers-sec">
              <div class="form-group has-search">
                <span class="fa fa-search form-control-feedback"></span>
                <input class="form-control" placeholder="Search..." type="text">
              </div>
              <div class="filter-menu">
                <a href="#">
                  <span></span>
                  <span></span>
                  <span></span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="top_selling_slider_main has-search-selling">
          <div class="row">
            <div class="col-md-4 col-lg-3">
              <div class="refine-sec-top">
                <div class="brand-header-top">
                  <div class="brand-header">
                    <p>Refine (28 results)</p>
                    <span class="mines-plus-circle">
                                                <i aria-hidden="true" class="flaticon-minus"></i>
                                            </span>
                  </div>
                </div>
                <div class="filter-right-sec">
                  <div class="myaccordion active">
                    <div class="brand-header">
                      <h3>Brands</h3>
                      <span class="mines-plus-circle">
                          <i aria-hidden="true" class="flaticon-minus"></i>
                      </span>
                    </div>
                    <div class="inner-accordion">
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox3" type="checkbox" value="option1"/>
                        <label for="inlineCheckbox3"> Air Jordan </label>
                      </div>
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox1" type="checkbox" value="option2"/>
                        <label for="inlineCheckbox1"> Adidas </label>
                      </div>
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox2" type="checkbox" value="option3"/>
                        <label for="inlineCheckbox2"> Nike </label>
                      </div>
                    </div>
                  </div>
                  <div class="myaccordion active padd-top-40">
                    <div class="brand-header">
                      <h3>Sizes</h3>
                      <span class="mines-plus-circle">
                                                    <i aria-hidden="true" class="flaticon-minus"></i>
                                                </span>
                    </div>
                    <div class="inner-accordion releasing-year-top">
                      <div class="sizes-input-field">
                        <div class="checkbox checkbox-inline">
                          <input id="inlineCheckbox10" type="checkbox" value="option10"/>
                          <label for="inlineCheckbox10"> Mens </label>
                        </div>
                        <div class="checkbox checkbox-inline">
                          <input id="inlineCheckbox11" type="checkbox" value="option11"/>
                          <label for="inlineCheckbox11"> Gradeschool</label>
                        </div>
                        <div class="checkbox checkbox-inline">
                          <input id="inlineCheckbox12" type="checkbox" value="option12"/>
                          <label for="inlineCheckbox12"> Kids </label>
                        </div>
                        <div class="checkbox checkbox-inline">
                          <input id="inlineCheckbox13" type="checkbox" value="option13"/>
                          <label for="inlineCheckbox13"> Toddlers </label>
                        </div>
                        <div class="checkbox checkbox-inline">
                          <input id="inlineCheckbox14" type="checkbox" value="option14"/>
                          <label for="inlineCheckbox14"> Womens </label>
                        </div>
                        <div class="checkbox checkbox-inline">
                          <input id="inlineCheckbox15" type="checkbox" value="option15"/>
                          <label for="inlineCheckbox15"> Infant </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="myaccordion active padd-top-40">
                    <div class="brand-header">
                      <h3>Colors</h3>
                      <span class="mines-plus-circle">
                                                    <i aria-hidden="true" class="flaticon-minus"></i>
                                                </span>
                    </div>
                    <div class="inner-accordion">
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox4" type="checkbox" value="option4"/>
                        <label for="inlineCheckbox4"> Red </label>
                      </div>
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox5" type="checkbox" value="option5"/>
                        <label for="inlineCheckbox5"> Blue</label>
                      </div>
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox6" type="checkbox" value="option6"/>
                        <label for="inlineCheckbox6"> Green </label>
                      </div>
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox7" type="checkbox" value="option7"/>
                        <label for="inlineCheckbox7"> Black </label>
                      </div>
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox8" type="checkbox" value="option8"/>
                        <label for="inlineCheckbox8"> White </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="top_selling_slider col-md-8 col-lg-9">
              <div class="row">
                <div class="top_selling_product_box col-lg-4 col-md-6">
                  <div class="top_sell_img border bg-white position-relative overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/top_selling_product_1.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20"
                           href="javascript:void(0);">Off-White x Air Force 1 Low-The
                      Ten</a></h3>
                    <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$230.00
                    </h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                </div>
                <div class="top_selling_product_box col-lg-4 col-md-6 mobile-top-product">
                  <div class="top_sell_img border bg-white position-relative overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/top_selling_product_2.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20"
                           href="javascript:void(0);">Off-White x Air Force 1 Low
                      '07'-MoMA</a></h3>
                    <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$270.00
                    </h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                </div>
                <div
                  class="top_selling_product_box col-lg-4 col-md-6 mobile-top-product mobile-top-product1">
                  <div class="top_sell_img border bg-white position-relative overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/top_selling_product_3.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20"
                           href="javascript:void(0);">Off-White x Air Max 90-Desert
                      Ore</a></h3>
                    <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$200.00
                    </h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                </div>
                <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                  <div class="top_sell_img border bg-white position-relative overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/new_releases_product_1.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Jordan
                      6 Retro DMP (2020)</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$230.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                </div>
                <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                  <div class="top_sell_img border bg-white overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/new_releases_product_2.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Adidas
                      Yeezy Boost 350 V2 Linen</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$270.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                </div>
                <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                  <div class="top_sell_img border bg-white overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/new_releases_product_3.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Jordan
                      1 Retro High Court Purple White</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$200.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                </div>
                <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                  <div class="top_sell_img border bg-white position-relative overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/featured_products_product_1.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Adidas
                      Yeezy Boost 350 V2 Cinder</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$255.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                </div>
                <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                  <div class="top_sell_img border bg-white overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/featured_products_product_2.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Adidas
                      Yeezy Boost 350 V2 Zebra</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$270.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                </div>
                <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                  <div class="top_sell_img border bg-white overflow-hidden">
                    <div class="add-top-cart-btn">
                      <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add
                        To Cart</a>
                    </div>
                    <a class="d-inline-block w-100 h-100 image_hover position-relative"
                       href="javascript:void(0);"><img
                      alt="" class="img-fluid"
                      src="/assets/images/featured_products_product_3.png"/></a>
                  </div>
                  <div class="top_sell_title text-center mt-3 ">
                    <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Jordan
                      1 Retro High Court Purple White</a></h3>
                    <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$200.00</h4>
                  </div>
                  <div class="cart-btn-mobile ">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                </div>
                <div
                  class="top_selling_product_box col-12 padd-top-product payouttt_offers_content text-center">
                  <a class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_26"
                     href="javascript:void(0);">View
                    All Products</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
